function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.2656 29C27.5123 29 31.7656 24.7467 31.7656 19.5C31.7656 14.2533 27.5123 10 22.2656 10C17.0189 10 12.7656 14.2533 12.7656 19.5C12.7656 24.7467 17.0189 29 22.2656 29Z",
    stroke: "#205A46",
    style: {
      stroke: "#205A46",
      stroke: "color(display-p3 0.1255 0.3529 0.2745)",
      strokeOpacity: 1
    },
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2656 26.5L32.7656 30",
    stroke: "#205A46",
    style: {
      stroke: "#205A46",
      stroke: "color(display-p3 0.1255 0.3529 0.2745)",
      strokeOpacity: 1
    },
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.dd1c72f238b1695ef53bb4f6f87b0d74.svg";
export { ForwardRef as ReactComponent };